import * as React from "react";
export class Icon extends React.Component {
    render() {
        return (React.createElement("span", { className: "rj-racing-future-events__event-view icon i-14 arrow-flat-right" }));
    }
}
//# sourceMappingURL=Icon.js.map